import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pms_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data.user);
        setCompany(r.data.company);
      })
      .catch(() => localStorage.removeItem("pms_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("pms_token", r.data.access_token);
    setUser(r.data.user);
    setCompany(r.data.company);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("pms_token");
    setUser(null);
    setCompany(null);
    window.location.href = "/login";
  };

  const refreshCompany = async () => {
    const r = await api.get("/auth/me");
    setCompany(r.data.company);
  };

  return (
    <AuthContext.Provider value={{ user, company, loading, login, logout, refreshCompany, setCompany }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
